<div class="flex w-full flex-col items-center justify-center">
    <div class="p-xl bg-card w-90 rounded-xl p-8 shadow-md sm:w-[420px]">
        <div class="flex flex-col gap-8">
            <div class="flex flex-col gap-4">
                <!-- <div *ngIf="activationStore.error()" class="error-container">
                    <mat-icon svgIcon="mat_outline:error_outline"></mat-icon>
                    <span>{{ activationStore.error() }}</span>
                </div> -->

                <div class="flex flex-col items-center gap-3">
                    <mat-icon
                        svgIcon="mat_outline:error_outline"
                        color="warn"
                        class="icon-size-8"
                    ></mat-icon>
                    <h1 class="text-center text-2xl font-semibold">
                        Link Expired
                    </h1>
                </div>
                @if (hasError) {
                    <fuse-alert [appearance]="'soft'" [type]="'error'">
                        {{ errorMessage }}
                    </fuse-alert>
                }
                <p class="text-center">
                    The activation link you followed is no longer valid. For
                    security, these links expire after 7 days.
                </p>
            </div>
            <div class="flex flex-col gap-4 rounded-xl bg-slate-100 p-4">
                <div class="flex gap-2">
                    <mat-icon
                        svgIcon="mat_outline:email"
                        color="primary"
                        class="icon-size-5"
                    ></mat-icon>
                    <div>
                        <h4 class="font-medium">Security Policy</h4>
                        <p class="text-sm">
                            Activation tokens are single-use and time-sensitive
                            to prevent unauthorized access to your account.
                        </p>
                    </div>
                </div>
                <div class="flex gap-2">
                    <mat-icon
                        svgIcon="mat_outline:autorenew"
                        color="primary"
                        class="icon-size-5"
                    ></mat-icon>
                    <div>
                        <h4 class="font-medium">Next Steps</h4>
                        <p class="text-sm">
                            {{ activation.message }}
                            @if (activation.newActivatonSent) {}
                        </p>
                    </div>
                </div>
            </div>

            <div
                class="flex items-center"
                [ngClass]="{
                    'justify-between': !activation.newActivatonSent,
                    'justify-center': activation.newActivatonSent,
                }"
            >
                @if (activation.showRequestButton) {
                    <button
                        type="button"
                        mat-flat-button
                        color="primary"
                        class="flex cursor-pointer gap-2"
                        (click)="requestNewLink()"
                        [disabled]="activationStore.isLoading()"
                    >
                        <mat-icon
                            [svgIcon]="'mat_outline:autorenew'"
                            class="icon-size-4"
                        ></mat-icon>
                        Request New Link
                    </button>
                }

                <button
                    type="button"
                    mat-stroked-button
                    color="primary"
                    class="flex cursor-pointer gap-2"
                    [routerLink]="['/sign-in']"
                >
                    <mat-icon
                        [svgIcon]="'mat_outline:arrow_back'"
                        class="icon-size-4"
                    ></mat-icon>
                    Back to Login
                </button>
            </div>
        </div>
    </div>
</div>
